import { ACTIONS } from '../constants';

export const resetData = () => {
  return { type: ACTIONS.RESET_DATA };
};

export const updateDataDisabled = (disabled) => {
  return { payload: disabled, type: ACTIONS.UPDATE_DATA_DISABLED };
};

export const updateDataErrors = (errors) => {
  return { payload: errors, type: ACTIONS.UPDATE_DATA_ERRORS };
};

export const updateDataFields = (fields) => {
  return { payload: fields, type: ACTIONS.UPDATE_DATA_FIELDS };
};

export const updateDataHidden = (hidden) => {
  return { payload: hidden, type: ACTIONS.UPDATE_DATA_HIDDEN };
};

export const updateDataValues = (values) => {
  return { payload: values, type: ACTIONS.UPDATE_DATA_VALUES };
};
